import React, { useMemo } from 'react';
import { Hourglass } from 'lucide-react';

export default function CoolingCountdownTile({ cooldown, skus, theme }) {
  const rows = useMemo(() => {
    const byCode = Object.fromEntries(skus.map(s => [s.sku, s]));
    return Object.entries(cooldown || {})
      .map(([sku, c]) => ({ sku, product: byCode[sku]?.product || '', ...c }))
      .sort((a, b) => a.daysLeft - b.daysLeft);
  }, [cooldown, skus]);

  return (
    <div className="fm-card p-5 mt-6" data-testid="cooling-countdown-tile">
      <div className="flex items-center gap-2 mb-1">
        <Hourglass size={16} style={{ color: theme.primary }} />
        <h3 className="text-[15px] font-medium">Testers in cooling period</h3>
        <span className="ml-auto text-[12px] text-[#7a6f5c]" data-testid="cooling-countdown-count">{rows.length} locked</span>
      </div>
      <p className="text-[12px] text-[#7a6f5c] mb-3">Delivered recently to your branch. Each can be ordered again on its eligible date, subject to stock.</p>
      {rows.length === 0 ? (
        <div className="text-[13px] text-[#4D7C5F]" data-testid="cooling-countdown-empty">No testers are in a cooling period — every SKU is orderable, subject to stock.</div>
      ) : (
        <div className="overflow-x-auto max-h-[340px] overflow-y-auto">
          <table className="w-full text-[13px]">
            <thead><tr className="text-left text-[12px] text-[#7a6f5c]">
              <th className="py-2 pr-4 font-medium">Tester SKU</th><th className="py-2 pr-4 font-medium">Product</th>
              <th className="py-2 pr-4 font-medium">Last delivered</th><th className="py-2 pr-4 font-medium">Cooling</th>
              <th className="py-2 pr-4 font-medium">Orderable from</th><th className="py-2 font-medium text-right">Days left</th>
            </tr></thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.sku} className="border-t border-[#EFEADB]" data-testid={`cooling-row-${r.sku}`}>
                  <td className="py-2 pr-4 font-mono">{r.sku}</td>
                  <td className="py-2 pr-4">{r.product}</td>
                  <td className="py-2 pr-4 whitespace-nowrap">{r.lastDeliveredDate}</td>
                  <td className="py-2 pr-4 whitespace-nowrap">{r.coolingDays} days</td>
                  <td className="py-2 pr-4 whitespace-nowrap font-medium" style={{ color: theme.primary }} data-testid={`cooling-next-${r.sku}`}>{r.nextEligibleDate}</td>
                  <td className="py-2 text-right">
                    <span className="px-2 py-0.5 rounded-full bg-[#F3EFE2] text-[12px]" data-testid={`cooling-days-left-${r.sku}`}>{r.daysLeft}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
